<template>
  <div class="pa-5">
    <v-card class="elevation-10" shaped>
      <v-card-title>
        <span>ข้อมูลการรายงานการดำเนินการ</span>
        <v-spacer></v-spacer>
        <v-btn small tile color="success" @click="add_detail">รายงาน</v-btn>
      </v-card-title>
      <v-card-text class="px-0">
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th style="width: 15%;">วัน/เดือน/ปี</th>
                <th style="width: 35%;">การดำเนินการ</th>
                <th style="width: 30%;">เอกสารอ้างอิง</th>
                <th style="width: 15%;">หมายเหตุ</th>
                <th style="width: 5%;"></th>
              </tr>
            </thead>

            <tbody v-if="detail && detail.length === 0">
              <v-subheader>ไม่พบข้อมูลการรายงาน</v-subheader>
            </tbody>

            <tbody v-else v-for="row in detail" :key="row.id">
              <tr>
                <td class="text-top">{{ row.operation_date | transform_date }}</td>
                <td class="py-2 text-top">{{ row.description }}</td>
                <td class="py-2 text-top">{{ row.reference }}</td>
                <td class="text-top">{{ row.note || '-' }}</td>
                <td>
                  <v-menu offset-y transition="fade-transition">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon v-on="on" v-bind="attrs"><v-icon>mdi-dots-vertical</v-icon></v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click="edit_detail(row)">
                        <v-list-item-icon><v-icon>mdi-pencil</v-icon></v-list-item-icon>
                        <v-list-item-title>แก้ไข</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="confirm_delete_detail(row.id)">
                        <v-list-item-icon><v-icon>mdi-delete</v-icon></v-list-item-icon>
                        <v-list-item-title>ลบ</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>

    <academicDetailForm 
      :dialog.sync="detail_dialog" 
      :form="detail_form"
      v-on:submit="submit"
    />

    <confirmDialog
      :dialog="detail_confirm_dialog"
      message="คุณต้องการลบข้อมูลนี้ใช่หรือไม่?"
      v-on:confirm="delete_detail"
    />
  </div>
</template>

<script>
import academicDetailFormDialog from './AcademicDetailFormDialog';
import confirmDialog from '@/components/ConfirmDialog';

export default {
  filters: {
    transform_date(value) {
      const event = new Date(value);
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      
      return event.toLocaleDateString('th-TH', options);
    }
  },
  components: {
    academicDetailForm: academicDetailFormDialog,
    confirmDialog: confirmDialog
  },
  data: () => ({
    detail_dialog: false,
    detail_confirm_dialog: false,
    detail_delete_selected: '',
    detail_submit_type: '',
    detail: [],
    detail_form: {
      operation_date: new Date().toISOString().substr(0, 10),
      short_description: '',
      description: '',
      reference: '',
      note: '',
      academic_id: ''
    }
  }),
  created() {
    this.detail_form.academic_id = this.$route.params.academic_id;
    this.load_data();
  },
  methods: {
    load_data() {
      this.$store.dispatch('academic/getAcademicDetail', this.$route.params.academic_id).then(data => this.detail = data);
    },
    submit() {
      this.$store.dispatch(`academic/${this.detail_submit_type === 'NEW' ? 'storeAcademicDetail' : 'updateAcademicDetail' }`, this.detail_form).then(res => {
        this.detail_dialog = false;
        this.load_data();
        this.$store.commit('SHOW_SNACKBAR', {
          color: 'success',
          message: res.message
        });
      }).catch(() => {
        this.academic_dialog = false;
        this.$store.commit('SHOW_SNACKBAR', {
          color: 'error',
          message: 'เกิดข้อผิดพลาดบางอย่าง'
        });
      })
    },
    add_detail() {
      this.detail_submit_type = 'NEW';
      this.detail_dialog = true;
      this.clear_form();
    },
    edit_detail(detail) {
      this.detail_submit_type = 'EDIT';
      this.detail_dialog = true;

      this.detail_form = {
        id: detail.id,
        academic_id: detail.academic_id,
        operation_date: detail.operation_date,
        short_description: detail.short_description,
        description: detail.description,
        reference: detail.reference,
        note: detail.note
      }
    },
    delete_detail(condition) {
      if(condition) {
        this.$store.dispatch('academic/deleteAcademicDetail', this.detail_delete_selected).then(res => {
          this.detail_confirm_dialog = false;
          this.load_data();
          this.$store.commit('SHOW_SNACKBAR', {
            color: 'success',
            message: res.message
          });
        }).catch(() => {
          this.detail_confirm_dialog = false;
          this.$store.commit('SHOW_SNACKBAR', {
            color: 'error',
            message: 'เกิดข้อผิดพลาดบางอย่าง'
          });
        })
      } else {
        this.detail_confirm_dialog = false;
      }
    },
    confirm_delete_detail(id) {
      this.detail_confirm_dialog = true;
      this.detail_delete_selected = id;
    },
    clear_form() {
      this.detail_form.operation_date = new Date().toISOString().substr(0, 10);
      this.detail_form.short_description = '';
      this.detail_form.description = '';
      this.detail_form.reference = '';
      this.detail_form.note = '';
    }
  }
}
</script>